import { BaseIcon, EthIcon } from 'src/common/assets'
import { ChainName } from './name'

export const CHAIN_NATIVE_TOKEN_ICON = {
  [ChainName.ETHEREUM]: EthIcon,
  [ChainName.BASE]: BaseIcon
}
